import FlashcardsAPI from "@/services/api/flashcards"
import { useQuery } from "@tanstack/react-query"

interface Props {
  learningPathId: string
}

const useGetSpecialDeck = ({ learningPathId }: Props) => {
  const query = useQuery({
    queryKey: ["get-special-deck"],
    queryFn: () => FlashcardsAPI.getSpecialDeck({ learningPathId }),
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled: !!learningPathId,
  })

  return query
}

export default useGetSpecialDeck
